import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormText,
  Modal
} from 'reactstrap';
import { validate } from '../services/validate';
import axios from 'axios';
import StorageService from '../services/StorageService';
import moment from 'moment-timezone';

class PosLicensingBillingForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            currency: 'SGD',
            due_date: moment().format('YYYY-MM-DD'),
            billing_date: moment().format('YYYY-MM-DD'),
            amount: 0,
            description: '',
            admin_email: '',
            payment_status: 'Pending Payment',
            admin_list: [],
            errors: {
                currency: '',
                due_date: '',
                billing_date: '',
                amount: '',
                admin_email: '',
                payment_status: '',
                description: ''
            }
        };
    }

    changeHandler = event => {
        this.setState({
        [event.target.name]: event.target.value,
        });
    };

    validateForm = (errors) => {
        let valid = true;
        Object.values(errors).forEach(
          (val) => val.length > 0 && (valid = false)
        );
        return valid;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { currency, due_date, billing_date, amount, admin_email, payment_status, description} = this.state;
        let errors = this.state.errors;

        errors.currency = (!validate.emptystring(currency)) ? 'Invalid input. Please select currency' : '';
        errors.due_date = (!validate.emptystring(due_date)) ? 'Invalid input. Please select due date' : '';
        errors.billing_date = (!validate.emptystring(billing_date)) ? 'Invalid input. Please enter bliling date' : '';
        errors.amount = (!validate.emptystring(amount)) ? 'Invalid input. Please enter billing amount' : !(/^\d+(,\d{3})*(\.\d{1,2})?$/.test(amount)) ? 'Invalid amount' : Number(amount) > 0 ? '' : 'Invalid input. Please enter billing amount';
        errors.admin_email = (!validate.emptystring(admin_email)) ? 'Invalid input. Please select admin email' : '';
        errors.payment_status = (!validate.emptystring(payment_status)) ? 'Invalid input. Please select payment status' : '';
        errors.description = (!validate.emptystring(description)) ? 'Invalid input. Please enter description' : '';
        

        if(this.validateForm(errors)) {
            if(this.props.isEdit) {
                this.props.update(this.state);
            } else {
                this.props.create(this.state);
            }
        }

        this.setState({ errors });
    };

    getAdminList = (company_id) => {
        const user = StorageService.getSession('user_info');
        const url = process.env.REACT_APP_API_URL;

        const data = {
        session_key: user.session_key,
        CompanyID: company_id,
        };

        axios
        .post(url + ':3000/v1/company/getUser', data)
        .then(response => {
            const result = response.data;

            if (result.error == true && result.message != 'Success') {
                alert(result.message);
                return;
            }

            this.setState({ admin_list: result.data.filter(el => el.Role == 'Admin') });
        })
        .catch(error => {
            console.log(error)
        });
    };

    componentDidMount() {
        this.setState({
            errors: {
                currency: '',
                due_date: '',
                billing_date: '',
                amount: '',
                admin_email: '',
                payment_status: '',
                description: ''
            }
        });

        if(this.props.isEdit) {
            if(this.props.item) {
                this.setState({ ...this.props.item });
            }
        } else {
            if(this.props.billing) {
                this.setState({ amount : this.props.billing.billing_amt });
            }
        }
        this.getAdminList(this.props.company_id);
    }

  render() {
    const isEdit = this.props.isEdit;
    const { errors } = this.state;

    return (
        
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.toggle('ADD', null)}>
          {isEdit ? 'Edit' : 'Create' } Billing
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
                <FormGroup>
                    <Label for="billing_date">Billing Date</Label>
                    <Input
                    type="date"
                    name="billing_date"
                    value={this.state.billing_date}
                    onChange={this.changeHandler}
                    />
                    {errors.billing_date.length > 0 && <FormText color="danger">{errors.billing_date}</FormText>}  
                </FormGroup>
                <FormGroup>
                    <Label for="due_date">Due Date</Label>
                    <Input
                    type="date"
                    name="due_date"
                    value={this.state.due_date}
                    onChange={this.changeHandler}
                    />
                    {errors.due_date.length > 0 && <FormText color="danger">{errors.due_date}</FormText>}  
                </FormGroup>
                <FormGroup>
                    <Label for="currency">Curreny</Label>
                    <Input
                        type="select"
                        name="currency"
                        value={this.state.currency}
                        onChange={this.changeHandler}>
                            <option value="SGD">SGD</option>
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Input
                        type="number"
                        step="any"
                        name="amount"
                        value={this.state.amount}
                        onChange={this.changeHandler}/>
                    {errors.amount.length > 0 && <FormText color="danger">{errors.amount}</FormText>}  
                </FormGroup>
                <FormGroup>
                    <Label for="description">Description</Label>
                    <Input
                        type="textarea"
                        name="description"
                        value={this.state.description}
                        onChange={this.changeHandler}/>  
                    {errors.description.length > 0 && <FormText color="danger">{errors.description}</FormText>}  
                </FormGroup>
                <FormGroup>
                    <Label for="admin_email">Admin Email</Label>
                    <Input
                        type="select"
                        name="admin_email"
                        value={this.state.admin_email}
                        onChange={this.changeHandler}>
                        <option value=""></option>
                        {this.state.admin_list.map((i, index) => {
                        return (
                            <option key={index} value={i.Email}>{i.Email}</option>
                        );
                        })}
                    </Input>
                    {errors.admin_email.length > 0 && <FormText color="danger">{errors.admin_email}</FormText>} 
                </FormGroup>
                <FormGroup>
                    <Label for="payment_status">Payment Status</Label>
                    <Input
                        type="select"
                        name="payment_status"
                        value={this.state.payment_status}
                        onChange={this.changeHandler}>
                        <option value="Pending Payment">PENDING PAYMENT</option>
                        <option value="Paid">PAID</option>
                    </Input>
                    {errors.payment_status.length > 0 && <FormText color="danger">{errors.payment_status}</FormText>} 
                </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.toggle('ADD', null)}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
          {isEdit ? 'Save Changes' : 'Create' }
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default PosLicensingBillingForm;
